import cn from 'clsx';
import React from 'react';

import styles from './ContentLayout.module.css';

type Props = {
  children?: React.ReactNode[] | React.ReactNode;
  dataId?: string;
  withActions?: boolean;
  withTitle?: boolean;
};

export const ContentLayout: React.FC<Props> = ({ children, dataId = 'contentLayout', withTitle, withActions }) => {
  return (
    <div className={cn(styles.root, withActions && styles.withActions, withTitle && styles.withTitle)} data-id={dataId}>
      {children}
    </div>
  );
};
